/** 双重预防机制 **/
import Layout from "@/views/layout/Layout";

const safetyPreventionRouter = {
  path: "/safetyPrevention",
  component: Layout,
  redirect: "/safetyPrevention/welcome",
  name: "safetyPrevention",
  meta: {
    title: "双重预防机制",
    icon: "safetyPrevention",
    roles: ["pre_shuangchongyufang"],
  },

  children: [
    {
      path: "welcome",
      component: () => import("@/views/safetyPrevention/welcome"),
      name: "safetyPreventionWelcome",
      hidden: true,
      meta: {
        title: "欢迎页",
        roles: ["pre_shuangchongyufang"],
      },
    },
    // 基础功能
    {
      path: "basicFunction",
      component: () => import("@/views/safetyPrevention/index"),
      name: "basicFunction",
      meta: {
        title: "基础功能",
        roles: ["pre_jichugongneng"],
      },
      children: [
        {
          path: "riskCategoryMan",
          component: () =>
            import("@/views/safetyPrevention/basicFunction/riskCategoryMan/index"),
          name: "riskCategoryMan",
          meta: {
            title: "排查分类管理",
            roles: ["pre_paichaifenleiguanli"],
          },
        },
        {
          path: "riskInfoMaintain",
          component: () =>
            import("@/views/safetyPrevention/basicFunction/riskInfoMaintain/index"),
          name: "riskInfoMaintain",
          meta: {
            title: "风险信息维护",
            roles: ["pre_fenxianxinxiweihu"],
          },
        },
      ],
    },
    // 公告栏
    {
      path: "noticeBoard",
      component: () => import("@/views/safetyPrevention/index"),
      name: "noticeBoard",
      meta: {
        title: "公告栏",
        roles: ["pre_gonggaolan"],
      },
      children: [
        {
          path: "noticePublish",
          component: () =>
            import("@/views/safetyPrevention/noticeBoard/noticePublish/index"),
          name: "noticePublish",
          meta: {
            title: "公告发布",
            roles: ["pre_gonggaofabu"],
          },
        },
        {
          path: "noticeView",
          component: () => import("@/views/safetyPrevention/index"),
          name: "noticeView",
          meta: {
            title: "公告查看",
            roles: ["pre_gonggaochakan"],
          },
          children: [
            {
              path: "promotion",
              component: () =>
                import("@/views/safetyPrevention/noticeBoard/noticeView/index"),
              name: "noticeViewPromotion",
              meta: {
                title: "宣传公告",
                roles: ["pre_gonggaochakan"],
                noticeType: "0",
              },
            },
            {
              path: "meeting",
              component: () =>
                import("@/views/safetyPrevention/noticeBoard/noticeView/index"),
              name: "noticeViewMeeting",
              meta: {
                title: "会议公告",
                roles: ["pre_gonggaochakan"],
                noticeType: "1",
              },
            },
            {
              path: "activity",
              component: () =>
                import("@/views/safetyPrevention/noticeBoard/noticeView/index"),
              name: "noticeViewActivity",
              meta: {
                title: "活动公告",
                roles: ["pre_gonggaochakan"],
                noticeType: "2",
              },
            },
          ],
        },
      ],
    },
    // 风险设备检验
    {
      path: "riskDeviceInspection",
      component: () => import("@/views/safetyPrevention/index"),
      name: "riskDeviceInspection",
      meta: {
        title: "风险设备检验",
        roles: ["pre_fengxianshebeijianyan"],
      },
      children: [
        {
          path: "riskDeviceMaintain",
          component: () =>
            import("@/views/safetyPrevention/riskDeviceInspection/riskDeviceMaintain/index"),
          name: "riskDeviceMaintain",
          meta: {
            title: "风险设备维护",
            roles: ["pre_fengxianshebeiweihu"],
          },
        },
        {
          path: "inspectionExecution",
          component: () =>
            import("@/views/safetyPrevention/riskDeviceInspection/inspectionExecution/index"),
          name: "inspectionExecution",
          meta: {
            title: "检验执行",
            roles: ["pre_fengxianjianyanzhixing"],
          },
        },
        {
          path: "inspectionQuery",
          component: () =>
            import("@/views/safetyPrevention/riskDeviceInspection/inspectionQuery/index"),
          name: "inspectionQuery",
          meta: {
            title: "检验信息查询",
            roles: ["pre_jianyanxinxichaxun"],
          },
        },
      ],
    },
    // 风险管控台账
    {
      path: "riskControlLedger",
      component: () => import("@/views/safetyPrevention/index"),
      name: "riskControlLedger",
      meta: {
        title: "风险管控台账",
        roles: ["pre_fengxianguankongtaizhang"],
      },
      children: [
        {
          path: "riskPointMaintain",
          component: () =>
            import("@/views/safetyPrevention/riskControlLedger/riskPointMaintain/index"),
          name: "riskPointMaintain",
          meta: {
            title: "风险点位维护",
            roles: ["pre_fengxiandianweiweihu"],
          },
        },
        {
          path: "riskPointQuery",
          component: () =>
            import("@/views/safetyPrevention/riskControlLedger/riskPointQuery/index"),
          name: "riskPointQuery",
          meta: {
            title: "风险点位查询",
            roles: ["pre_fengxiandianweichaxun"],
          },
        },
      ],
    },
    // 风险排查管理
    {
      path: "riskInspectionMan",
      component: () => import("@/views/safetyPrevention/index"),
      name: "riskInspectionMan",
      meta: {
        title: "风险排查管理",
        roles: ["pre_fengxianpaichaguanli"],
      },
      children: [
        {
          path: "inspectionTaskExec",
          component: () =>
            import("@/views/safetyPrevention/riskInspectionMan/inspectionTaskExec/index"),
          name: "inspectionTaskExec",
          meta: {
            title: "排查任务执行",
            roles: ["pre_paicharenwuzhixing"],
          },
        },
        {
          path: "rectificationTask",
          component: () =>
            import("@/views/safetyPrevention/riskInspectionMan/rectificationTask/index"),
          name: "rectificationTask",
          meta: {
            title: "排查任务整改",
            roles: ["pre_paicharenwuzhenggai"],
          },
        },
        {
          path: "rectificationSupervision",
          component: () =>
            import("@/views/safetyPrevention/riskInspectionMan/rectificationSupervision/index"),
          name: "rectificationSupervision",
          meta: {
            title: "整改监管",
            roles: ["pre_paichazhenggaijianguan"],
          },
        },
        {
          path: "inspectionTaskQuery",
          component: () =>
            import("@/views/safetyPrevention/riskInspectionMan/inspectionTaskQuery/index"),
          name: "inspectionTaskQuery",
          meta: {
            title: "排查任务查询",
            roles: ["pre_paicharenwuchaxun"],
          },
        },
        {
          path: "selfTaskRecord",
          component: () =>
            import("@/views/safetyPrevention/riskInspectionMan/selfTaskRecord/index"),
          name: "selfTaskRecord",
          meta: {
            title: "自发任务记录",
            roles: ["pre_zifarenwujilu"],
          },
        },
        {
          path: "selfTaskView",
          component: () =>
            import("@/views/safetyPrevention/riskInspectionMan/selfTaskView/index"),
          name: "selfTaskView",
          meta: {
            title: "自发任务查询",
            roles: ["pre_zifarenwuchaxun"],
          },
        },
      ],
    },
    // 风险治理管理
    {
      path: "riskGovernanceMan",
      component: () => import("@/views/safetyPrevention/index"),
      name: "riskGovernanceMan",
      meta: {
        title: "风险治理管理",
        roles: ["pre_fengxianzhiliguanli"],
      },
      children: [
        {
          path: "samplingTaskExec",
          component: () =>
            import("@/views/safetyPrevention/riskGovernanceMan/samplingTaskExec/index"),
          name: "samplingTaskExec",
          meta: {
            title: "抽检任务执行",
            roles: ["pre_choujianrenwuzhixing"],
          },
        },
        {
          path: "samplingRectification",
          component: () =>
            import("@/views/safetyPrevention/riskGovernanceMan/samplingRectification/index"),
          name: "samplingRectification",
          meta: {
            title: "抽检任务整改",
            roles: ["pre_choujianrenwuzhenggai"],
          },
        },
        {
          path: "samplingSupervision",
          component: () =>
            import("@/views/safetyPrevention/riskGovernanceMan/samplingSupervision/index"),
          name: "samplingSupervision",
          meta: {
            title: "整改监管",
            roles: ["pre_choujianzhenggaijianguan"],
          },
        },
        {
          path: "samplingTaskQuery",
          component: () =>
            import("@/views/safetyPrevention/riskGovernanceMan/samplingTaskQuery/index"),
          name: "samplingTaskQuery",
          meta: {
            title: "抽检任务查询",
            roles: ["pre_choujianrenwuchaxun"],
          },
        },
      ],
    },
    // 报表分析
    {
      path: "reportAnalysis",
      component: () => import("@/views/safetyPrevention/index"),
      name: "reportAnalysis",
      meta: {
        title: "报表分析",
        roles: ["pre_fengxianzhiliguanli"],
      },
      children: [
        {
          path: "riskLedgerStatistics",
          component: () =>
            import("@/views/safetyPrevention/reportAnalysis/riskLedgerStatistics/index"),
          name: "riskLedgerStatistics",
          meta: {
            title: "风险台账统计",
            roles: ["pre_fengxiantaizhangtongji"],
          },
        },
        {
          path: "selfInspectionStatistics",
          component: () =>
            import("@/views/safetyPrevention/reportAnalysis/selfInspectionStatistics/index"),
          name: "selfInspectionStatistics",
          meta: {
            title: "自检结果统计",
            roles: ["pre_zijianjieguotongji"],
          },
        },
        {
          path: "samplingStatistics",
          component: () =>
            import("@/views/safetyPrevention/reportAnalysis/samplingStatistics/index"),
          name: "samplingStatistics",
          meta: {
            title: "抽检结果统计",
            roles: ["pre_choujianjieguotongji"],
          },
        },
        {
          path: "deviceInspectionStatistics",
          component: () =>
            import("@/views/safetyPrevention/reportAnalysis/deviceInspectionStatistics/index"),
          name: "deviceInspectionStatistics",
          meta: {
            title: "设备检验统计",
            roles: ["pre_shebeijianyantongji"],
          },
        },
      ],
    },
  ],
};

export default safetyPreventionRouter;

